"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAllSettledResult = exports.Poller = exports.sortCountriesAlphabetically = exports.sortAlphabetically = exports.uniqueId = exports.filterDataFromObjectByKey = exports.isNullOrUndefined = exports.mergeObjectDeep = exports.mergeObjectsFromArray = exports.isEmptyObject = exports.isObject = exports.getIn = void 0;
exports.cloneDeep = cloneDeep;
const tslib_1 = require("tslib");
const getIn = (object, path) => path.split('.').reduce((previousValue, currentValue) => previousValue === null || previousValue === void 0 ? void 0 : previousValue[currentValue], object);
exports.getIn = getIn;
const isObject = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
exports.isObject = isObject;
const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
exports.isEmptyObject = isEmptyObject;
const mergeObjectsFromArray = (arrayOfObjects) => arrayOfObjects.reduce((acc, curr) => (Object.assign(Object.assign({}, acc), curr)), {});
exports.mergeObjectsFromArray = mergeObjectsFromArray;
const mergeObjectDeep = (...objects) => {
    const isValueObject = obj => obj && typeof obj === 'object';
    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach(key => {
            const pVal = prev[key];
            const oVal = obj[key];
            if (Array.isArray(pVal) && Array.isArray(oVal)) {
                prev[key] = pVal.concat(...oVal);
            }
            else if (isValueObject(pVal) && isValueObject(oVal)) {
                prev[key] = (0, exports.mergeObjectDeep)(pVal, oVal);
            }
            else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, {});
};
exports.mergeObjectDeep = mergeObjectDeep;
const isNullOrUndefined = (obj) => {
    return obj === null || obj === undefined || typeof obj === 'undefined';
};
exports.isNullOrUndefined = isNullOrUndefined;
const filterDataFromObjectByKey = (keyedObject, keyToFilter) => {
    if (keyedObject && keyToFilter) {
        return keyedObject[keyToFilter.toUpperCase()];
    }
    return null;
};
exports.filterDataFromObjectByKey = filterDataFromObjectByKey;
const uniqueId = (prefix = '', suffix = '', length = 8) => {
    const randomChars = Math.random().toString(36).substring(2, 4);
    const randomNumbers = Math.random().toString().slice(2, length);
    return `${prefix}${randomChars}${randomNumbers}${suffix}`;
};
exports.uniqueId = uniqueId;
const sortAlphabetically = (array, key, compareOptions = {
    sensitivity: 'base',
    numeric: true,
}) => [...array].sort((a, b) => {
    const compareA = key ? (0, exports.getIn)(a, key) : a;
    const compareB = key ? (0, exports.getIn)(b, key) : b;
    return compareA.toString().localeCompare(compareB.toString(), undefined, compareOptions);
});
exports.sortAlphabetically = sortAlphabetically;
const sortCountriesAlphabetically = (array, language) => [...array].sort((a, b) => {
    const compareA = a.countryTranslations[language === null || language === void 0 ? void 0 : language.toUpperCase()].countryDescription;
    const compareB = b.countryTranslations[language === null || language === void 0 ? void 0 : language.toUpperCase()].countryDescription;
    return compareA.localeCompare(compareB, undefined, {
        sensitivity: 'base',
        numeric: true,
    });
});
exports.sortCountriesAlphabetically = sortCountriesAlphabetically;
class Poller {
    constructor(fn, interval) {
        this.fn = fn;
        this.interval = interval;
        this.active = false;
    }
    run() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.active = true;
            const wait = () => new Promise(resolve => setTimeout(resolve, this.interval));
            let result = yield this.fn();
            while (!result && this.active) {
                yield wait();
                if (!this.active) {
                    break;
                }
                result = yield this.fn();
            }
            return result;
        });
    }
    end() {
        this.active = false;
    }
}
exports.Poller = Poller;
function cloneDeep(source) {
    if (Array.isArray(source)) {
        return source.map(item => cloneDeep(item));
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source && typeof source === 'object') {
        return Object.getOwnPropertyNames(source).reduce((acc, prop) => {
            Object.defineProperty(acc, prop, Object.getOwnPropertyDescriptor(source, prop));
            acc[prop] = cloneDeep(source[prop]);
            return acc;
        }, Object.create(Object.getPrototypeOf(source)));
    }
    else {
        return source;
    }
}
const handleAllSettledResult = ({ result, onError, fallbackValue = null, }) => {
    if (result.status === 'fulfilled') {
        return result.value || fallbackValue;
    }
    else {
        onError === null || onError === void 0 ? void 0 : onError(result.reason);
        return fallbackValue;
    }
};
exports.handleAllSettledResult = handleAllSettledResult;
//# sourceMappingURL=general.util.js.map